/**
 * KAYA COLLECTION TABS CAROUSEL
 * Handles tab switching, hero updates, and keyboard navigation.
 */
(function () {
  'use strict';

  class KayaCollectionTabsCarousel {
    constructor(section) {
      this.section = section;
      this.tabs = Array.from(section.querySelectorAll('[data-kaya-tab]'));
      this.panels = Array.from(section.querySelectorAll('[data-kaya-panel]'));
      this.heroImage = section.querySelector('[data-kaya-hero-img]');
      this.heroTitle = section.querySelector('[data-kaya-hero-title]');
      this.heroLink = section.querySelector('[data-kaya-hero-link]');
      this.heroCta = section.querySelector('[data-kaya-hero-cta]');
      this.leftMode = section.dataset.kayaLeftMode || 'manual';

      if (this.tabs.length === 0) return;

      this._bindEvents();
      this._initFromURL();
    }

    _bindEvents() {
      // Tab clicks
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          this._activateTab(tab);
        }.bind(this));
      }.bind(this));

      // Keyboard navigation on tab bar
      var tabList = this.section.querySelector('[role="tablist"]');
      if (tabList) {
        tabList.addEventListener('keydown', function (e) {
          this._handleKeydown(e);
        }.bind(this));
      }
    }

    _initFromURL() {
      var params = new URLSearchParams(window.location.search);
      var tabIndex = params.get('tab');
      var collectionHandle = params.get('collection');

      if (tabIndex !== null) {
        var idx = parseInt(tabIndex, 10);
        if (this.tabs[idx]) {
          this._activateTab(this.tabs[idx], false);
          return;
        }
      }

      if (collectionHandle) {
        for (var i = 0; i < this.tabs.length; i++) {
          if (this.tabs[i].dataset.collectionHandle === collectionHandle) {
            this._activateTab(this.tabs[i], false);
            return;
          }
        }
      }
    }

    _activateTab(tab, focus) {
      var index = parseInt(tab.dataset.kayaTab, 10);

      // Update tab states
      this.tabs.forEach(function (t) {
        var isActive = t === tab;
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      // Update panel visibility
      this.panels.forEach(function (panel) {
        var panelIndex = parseInt(panel.dataset.kayaPanel, 10);
        if (panelIndex === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      // Update hero if active_collection mode
      if (this.leftMode === 'active_collection') {
        this._updateHero(tab);
      }

      // Scroll the active tab into view within the tab bar
      tab.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });

      if (focus !== false) {
        tab.focus({ preventScroll: true });
      }
    }

    _updateHero(tab) {
      var imgUrl = tab.dataset.collectionImage || '';
      var title = tab.dataset.collectionTitle || '';
      var url = tab.dataset.collectionUrl || '#';

      if (this.heroImage) {
        if (imgUrl) {
          this.heroImage.setAttribute('src', imgUrl);
          this.heroImage.setAttribute('srcset', '');
          this.heroImage.closest('.kaya-ctc__hero').classList.remove('kaya-ctc__hero--placeholder');
        } else {
          this.heroImage.setAttribute('src', '');
          this.heroImage.closest('.kaya-ctc__hero').classList.add('kaya-ctc__hero--placeholder');
        }
      }

      if (this.heroTitle) {
        this.heroTitle.textContent = title;
      }

      if (this.heroLink) {
        this.heroLink.setAttribute('href', url);
      }

      if (this.heroCta) {
        this.heroCta.setAttribute('href', url);
      }
    }

    _handleKeydown(e) {
      var currentIndex = this.tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      var newIndex = -1;

      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          e.preventDefault();
          newIndex = (currentIndex + 1) % this.tabs.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          e.preventDefault();
          newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          break;
        case 'Home':
          e.preventDefault();
          newIndex = 0;
          break;
        case 'End':
          e.preventDefault();
          newIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      if (newIndex >= 0 && this.tabs[newIndex]) {
        this._activateTab(this.tabs[newIndex]);
      }
    }
  }

  // ---------- INITIALIZATION ----------

  function initSections() {
    document.querySelectorAll('[data-kaya-ctc-section]').forEach(function (el) {
      if (!el._kayaCTC) {
        el._kayaCTC = new KayaCollectionTabsCarousel(el);
      }
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSections);
  } else {
    initSections();
  }

  // Re-init when Shopify editor loads/selects sections
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-kaya-ctc-section]');
    if (section) {
      section._kayaCTC = new KayaCollectionTabsCarousel(section);
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('[data-kaya-ctc-section]');
    if (!section) return;
    var blockId = e.detail.blockId;
    var tab = section.querySelector('[data-kaya-tab][data-block-id="' + blockId + '"]');
    if (tab && section._kayaCTC) {
      section._kayaCTC._activateTab(tab);
    }
  });
})();
